import { render, staticRenderFns } from "./multi-coupons-select-modal.vue?vue&type=template&id=12ddf36c&scoped=true&lang=pug&"
import script from "./multi-coupons-select-modal.vue?vue&type=script&lang=js&"
export * from "./multi-coupons-select-modal.vue?vue&type=script&lang=js&"
import style0 from "./multi-coupons-select-modal.vue?vue&type=style&index=0&id=12ddf36c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ddf36c",
  null
  
)

export default component.exports